(() => {
  const PRODUCT_SELECTOR = 'product-info.eonix-pdp-native';

  const setTextIfChanged = (element, value) => {
    if (!element || !value || element.textContent.trim() === value) return;
    element.textContent = value;
  };

  const syncPlan = (choice) => {
    const root = choice.closest(PRODUCT_SELECTOR);
    const hidden = root?.querySelector('[data-eonix-selling-plan]');
    if (!hidden) return;
    hidden.value = choice.value;
    hidden.disabled = choice.value === '';

    const selectedPrice = choice.dataset.eonixPlanPrice;
    if (selectedPrice) {
      setTextIfChanged(root.querySelector('[data-eonix-submit-price]'), selectedPrice);
      setTextIfChanged(root.querySelector('[data-eonix-sticky-price]'), selectedPrice);
    }
  };

  const syncSticky = (root) => {
    const sticky = root.querySelector('[data-eonix-sticky]');
    const submit = root.querySelector('.product-form__submit');
    const price = root.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular');
    if (!sticky || !submit) return;

    const stickyButton = sticky.querySelector('[data-eonix-sticky-submit]');
    const stickyPrice = sticky.querySelector('[data-eonix-sticky-price]');
    const selectedPlan = root.querySelector('[data-eonix-plan-choice]:checked');
    const displayedPrice = selectedPlan?.dataset.eonixPlanPrice || price?.textContent?.trim();

    if (stickyButton) {
      stickyButton.disabled = submit.disabled;
      const buttonLabel = submit.querySelector('[data-eonix-submit-label], span')?.textContent?.trim();
      setTextIfChanged(stickyButton, buttonLabel);
    }
    if (stickyPrice && displayedPrice) setTextIfChanged(stickyPrice, displayedPrice);

    const submitPrice = root.querySelector('[data-eonix-submit-price]');
    if (submitPrice && displayedPrice) setTextIfChanged(submitPrice, displayedPrice);
  };

  const initSummaryTabs = (root) => {
    const tablist = root.querySelector('[data-eonix-summary-tabs]');
    if (!tablist || tablist.dataset.eonixTabsReady === 'true') return;

    const tabs = Array.from(tablist.querySelectorAll('[data-eonix-summary-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-eonix-summary-panel]'));
    if (!tabs.length || !panels.length) return;

    tablist.dataset.eonixTabsReady = 'true';
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const selected = tab.dataset.eonixSummaryTab;
        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          const active = panel.dataset.eonixSummaryPanel === selected;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });
    });
  };

  const initSticky = (root) => {
    if (root.dataset.eonixStickyReady === 'true') {
      syncSticky(root);
      return;
    }

    const sticky = root.querySelector('[data-eonix-sticky]');
    const submit = root.querySelector('.product-form__submit');
    if (!sticky || !submit) return;

    root.dataset.eonixStickyReady = 'true';
    syncSticky(root);

    const observer = new IntersectionObserver(
      ([entry]) => {
        const active = !entry.isIntersecting;
        sticky.classList.toggle('is-active', active);
        sticky.setAttribute('aria-hidden', active ? 'false' : 'true');
      },
      { threshold: 0.2 }
    );
    observer.observe(submit);

    const mutationObserver = new MutationObserver(() => syncSticky(root));
    mutationObserver.observe(submit, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
    });

    const price = root.querySelector('[id^="price-"]');
    if (price) {
      mutationObserver.observe(price, {
        subtree: true,
        childList: true,
        characterData: true,
      });
    }
  };

  const initialise = (scope = document) => {
    const roots = scope.matches?.(PRODUCT_SELECTOR)
      ? [scope]
      : Array.from(scope.querySelectorAll?.(PRODUCT_SELECTOR) || []);
    roots.forEach((root) => {
      initSummaryTabs(root);
      initSticky(root);
    });
  };

  document.addEventListener('change', (event) => {
    const choice = event.target.closest?.('[data-eonix-plan-choice]');
    if (choice) syncPlan(choice);

    const root = event.target.closest?.(PRODUCT_SELECTOR);
    if (root) requestAnimationFrame(() => syncSticky(root));
  });

  document.addEventListener('click', (event) => {
    const stickyButton = event.target.closest?.('[data-eonix-sticky-submit]');
    if (!stickyButton) return;
    const root = stickyButton.closest(PRODUCT_SELECTOR);
    const submit = root?.querySelector('.product-form__submit');
    if (submit && !submit.disabled) submit.click();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  } else {
    initialise(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
